import Vue from 'vue';
import app from '@/main'
import { errorHandler } from './error-handler'
import secret from "@/utils/secret"

function resolveRequestError(err, throwAll = true, popToast = true) {

	const { status, data } = errorHandler(err)
	if (status === 403) {
		return
	}
	// if form validation errors are present, throw it so the caller can catch it
	if (data.data && Object.entries(data.data).length != 0){
		if(data.message){
			app.$store.dispatch('toast', {
				message : data.message,
				variant: 'error'
			})
		}
		throw data.data;
	}
	let text = data.message
	if (!text) text = data;
	if (popToast)
		app.$store.dispatch('toast', {
			message: text,
			variant: 'error'
		})

	if (status === 0 && !popToast)
		app.$store.dispatch('toast', {
			message: text,
			variant: 'error'
		})

	if (throwAll) throw data
}

function isUserLoggedIn() {
	try {
		const status = sessionStorage.getItem('access');
		const decryptedText = Vue.CryptoJS.AES.decrypt(status, secret).toString(Vue.CryptoJS.enc.Utf8);
		if(decryptedText === 'true'){
			return true
		}
		else{
			return false
		}
	} catch (error) {
		return false
	}
}

export { resolveRequestError, isUserLoggedIn }
